// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"13d2ca96","239":"d001237b","455":"e0bb8a61"}[chunkId] + ".chunk.js";
};